import React from 'react';
import { ActionIcon, Button, Group, Text, Tooltip } from '@mantine/core';
import { IconPlus, IconRefresh } from '@tabler/icons-react';
import type { Table } from '@tanstack/react-table';
import Tabla from '../../../globales/componentes/tabla/tabla';
import type { ICotizacionPostventaResumen } from '../../../modelos/CotizadorPostventa/entidades/ICotizacionPostventa';

interface TablaCotizacionesPostventaVistaProps {
    tabla: Table<ICotizacionPostventaResumen>;
    alCrearNueva: () => void;
    alRefrescar: () => void;
}

/** Listado de cotizaciones postventa. */
export const TablaCotizacionesPostventaVista: React.FC<TablaCotizacionesPostventaVistaProps> = ({ tabla, alCrearNueva, alRefrescar }) => (
    <>
        <Group justify="space-between" mb="md">
            <Text fw={700} size="lg">Cotizaciones Postventa</Text>
            <Group>
                <Button color="primary" variant="light" size="xs" radius="lg" leftSection={<IconPlus color="var(--mantine-color-primary-0)" size={12} />} onClick={alCrearNueva}>
                    <Text fw={500} size="xs">Nueva Cotización</Text>
                </Button>
                <Tooltip label="Refrescar" withinPortal openDelay={100} zIndex={9999} style={{ fontSize: '10px', padding: '3px 5px' }}>
                    <ActionIcon variant="subtle" color="primary" radius="xl" onClick={alRefrescar}>
                        <IconRefresh size={16} />
                    </ActionIcon>
                </Tooltip>
            </Group>
        </Group>
        <Tabla maxHeight={350} tabla={tabla} />
        {tabla.getRowCount() === 0 && <Text size="xs" c="dimmed" ta="center" mt="sm">Aún no hay cotizaciones postventa.</Text>}
    </>
);
